import { render, staticRenderFns } from "./LinkFailure.vue?vue&type=template&id=2daf8be6&scoped=true"
import script from "./LinkFailure.vue?vue&type=script&lang=js"
export * from "./LinkFailure.vue?vue&type=script&lang=js"
import style0 from "./LinkFailure.vue?vue&type=style&index=0&id=2daf8be6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daf8be6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2daf8be6')) {
      api.createRecord('2daf8be6', component.options)
    } else {
      api.reload('2daf8be6', component.options)
    }
    module.hot.accept("./LinkFailure.vue?vue&type=template&id=2daf8be6&scoped=true", function () {
      api.rerender('2daf8be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LinkFailure.vue"
export default component.exports